import styled from "styled-components";
import { color } from "../../styles";

export interface StatusProps {
  $backgroundColor?: string;
  $color?: string;
  $width?: string;
  onClick?: () => void;
}

export const StatusWrapper = styled.div<StatusProps>`
  padding: 4px 8px;
  border-radius: 5px;
  height: 16px;
  font-size: 11px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  gap: 4px;

  width: ${(props: StatusProps) => props.$width || "fit-content"};
  font-family: "Noto Sans";

  color: ${(props: StatusProps) =>
    props.$color ? props.$color : color.secondary.DARK_GREY};

  background-color: ${(props: StatusProps) =>
    props.$backgroundColor ? props.$backgroundColor : color.secondary.DARK_GREY};

  border: 1px solid ${color.emphasis.NEUTRAL_N10};

  &:hover {
    ${(props: StatusProps) => props.onClick && "cursor: pointer;"}
  }
`;
